    import React, { useEffect, useState } from "react";
    import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
    import axios from "axios";
    import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
    import InventoryNav from "../components/inventoryNav";
    import Time from "../components/time";
    import { Link } from "react-router-dom";

    const GrnInspection = () => {
        useAuthRedirect();
    const [data, setData] = useState([]);
    const branch = localStorage.getItem("branch");
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);

    const canView  = hasPermission("GRN", "view");
    const canEntry  = hasPermission("GRN", "entry");
    
    useEffect(() => {
        fetchData();
    }, [branch]);

    const fetchData = async () => {
        setLoading(true);
        try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/grnInspection_list?branch=${branch}`);
        setData(response.data.grnList);
        setFilteredData(response.data.grnList);
        } catch (error) {
        console.error("Error fetching grnList:", error);
        } finally {
        setLoading(false);
        }
    };

    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);
    
        if (term === "") {
            setFilteredData(data);
            return;
        }
    
        const filtered = data.filter((item) => 
            String(item.grnheader_number || "").toLowerCase().includes(term) || 
            String(item.GRNHeader_suppliercode || "").toLowerCase().includes(term)
        );
    
        setFilteredData(filtered);
    };
    
if (!(canView && canEntry)) {
  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right" style={{ padding: 20 }}>
        <Access />
      </div>
    </div>
  );
}

    // Pagination
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <div id="admin-container">
        <InventoryNav />
        <div className="content-right">
            <section>
                           <div className="back-div">
                                        <h2 className="add-txt">GRN Inspection Note</h2>
                                        <Link to='/inventory/grnmenu'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                      </div>
            <Time />
            </section>

{canEntry && (
            <div className="next-container">
            <Link to={`/inventory/grnConfirm`}>
                <button className="next-btn">
                    Next GRN Confirm<i className="fa-solid fa-arrow-right"></i> 
                </button>
            </Link>
            </div>
)}

            {/* Search Filter */}
            <div className="search-filter">
            <p>Search: </p>
            <input
                type="text"
                placeholder="Search by GRN No"
                value={searchTerm}
                onChange={handleSearch}
                className="search-input"
            />
            </div>

            {/* Table */}
            <div className="content-table">
            <table>
                <thead>
                <tr>
                    <th>S.No</th>
                    <th>GRN No</th>
                    <th>GRN Date</th>
                    <th>Supplier Code</th>
                    <th>Supplier Name</th>
                </tr>
                </thead>
                <tbody>
                {loading ? (
                    <tr>
                    <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                    </tr>
                ) : currentData.length > 0 ? (
                    currentData.map((item, index) => (
                    <tr key={index}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>
                        <Link to={`/inventory/grnInspectionViewSingle/${item.grnheader_number}/${item.grndetail_poNumber}`}>
                            {item.grnheader_number}
                        </Link>
                        </td>
                        <td>{new Date(item.GRNHeader_Date).toLocaleDateString()}</td>
                        <td>{item.GRNHeader_suppliercode}</td>
                        <td>{item.SupplierMaster_Name}</td>
                    </tr>
                    ))
                ) : (
                    <tr>
                    <td colSpan="6">No Data Available</td>
                    </tr>
                )}
                </tbody>
            </table>
            </div>

            {/* Pagination */}
            <div className="pagination">
            <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                Previous
            </button>

            {/* Always show first page */}
            <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
                1
            </button>

            {/* Show up to 3 pages dynamically */}
            {filteredData.length > 0 &&
                [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
                const pageNumber = currentPage + index;
                if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                    return (
                    <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                        {pageNumber}
                    </button>
                    );
                }
                return null;
                })
            }

            {/* Next button */}
            <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
                Next
            </button>
            </div>
        </div>
        </div>
    );
    };

    export default GrnInspection;
